import { Activity } from '@/types/activities'
import { ActivityProvider } from './ActivityItemProvider'
import { ActivityItem } from './ActivityItem'
import { RegistrationCheckContext } from '@/providers/registration-check-provider'
import { ReactElement, use } from 'react'

type Props = {
    updateActivity: (activity: Activity) => void
    deleteActivity: (activity: Activity) => void
}

export const Activities = ({ updateActivity, deleteActivity }: Props): ReactElement => {
    const { activities } = use(RegistrationCheckContext)

    return (
        <div>
            {activities &&
                activities.map((activity) => (
                    <ActivityProvider
                        key={activity.id}
                        activity={activity}
                        canBeDeleted={activities.length > 1}
                        deleteActivity={() => deleteActivity(activity)}
                        updateActivity={updateActivity}
                    >
                        <ActivityItem />
                    </ActivityProvider>
                ))}
        </div>
    )
}
